import Sortable from 'sortablejs';

import imagesLoaded from 'assets/js/images-loaded-directive';
import { SanitizeHTML } from 'assets/js/mixins/sanitize';

// despacify removes newlines, tabs, and spaces between tags. Not currently
// needed.
const despacify = (str) => str
  .replace(/\n|\r|\r\n/gm, '')
  .replace(/>(\s|\t|\n|\r)+</gm, '><')
  .replace(/\s*</g, '<')
  .replace(/>\s*/g, '>');

// focus focuses on an element when it is inserted.
const focus = {
  mounted(el, binding) {
    if (binding && binding.value) return;
    el.focus();
  },
};

const safeHtml = {
  mounted(elArg, binding) {
    const el = elArg;
    el.innerHTML = SanitizeHTML(binding.value);
  },
  updated(elArg, binding) {
    const el = elArg;
    el.innerHTML = SanitizeHTML(binding.value);
  },
};

const sortable = {
  mounted: (el, binding) => {
    if (!binding.value.applyDirective) return;
    const _ = new Sortable(el, binding.value || {});
  },
};

export const mixinDirectives = {
  focus,
  imagesLoaded,
  safeHtml,
  sortable,
};
